import React from 'react';
import Input from '../Input';
import { create } from 'react-test-renderer';
import { render, screen } from '@testing-library/react';

describe('Component Input', () => {
  it('should have a placeholder', () => {
    const text = 'placeholderText';
    render(<Input placeholder={text} />);
    expect(screen.getByPlaceholderText(`${text}`)).toBeInTheDocument(); 
  });

  it('should have a label', () => {
    const text = 'label';
    render(<Input label={text} />);
    expect(screen.getByLabelText(`${text}`)).toBeInTheDocument(); 
  });

  it('should have a required symbol', () => {
    render(<Input required={true} />);
    expect(screen.getByLabelText('required')).toBeInTheDocument();
  });

  it('should display errors', () => {
    const notice = "errormessage";
    render(<Input errorMessage={notice} />);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === notice))
      .toBeInTheDocument();
    expect(screen.getByRole('img', { name: /error/ })).toBeInTheDocument();
  });

  it('should display warnings', () => {
    const notice = "warning";
    render(<Input warningMessage={notice} />);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === notice))
    .toBeInTheDocument();
    expect(screen.getByRole('img', { name: /warning/ })).toBeInTheDocument();
  });

  it('should display success', () => {
    const notice = "successmessage";
    render(<Input successMessage={notice} />);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === notice))
      .toBeInTheDocument();
    expect(screen.getByRole('img', { name: /success/ })).toBeInTheDocument();
  });

  it('should display info', () => {
    const notice = "infomessage";
    render(<Input infoMessage={notice} />);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === notice))
      .toBeInTheDocument();
      expect(screen.getByRole('img', { name: /info/ })).toBeInTheDocument();
  });

  describe('snapshots', () => {

    it('should render input', () => {
      const component = create(<Input />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should render component with placeholder', () => {
      const component = create(<Input placeholder="placeholderText" />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should have a label', () => {
      const component = create(<Input label="label" />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should have a required symbol', () => {
      const component = create(<Input required={true} />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should display errors', () => {
      const notice = "errormessage";
      const component = create(<Input errorMessage={notice} />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should display warnings', () => {
      const notice = "warning";
      const component = create(<Input warningMessage={notice} />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should display success', () => {
      const notice = "successmessage";
      const component = create(<Input successMessage={notice} />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should display info', () => {
      const notice = "infomessage";
      const component = create(<Input infoMessage={notice} />).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
